import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import {makeStyles} from "@material-ui/core";
import StreamlineIcon from "./StreamlineIcon";
import SmileyUnhappy1 from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/messages-chat-smileys/smileys/smiley-unhappy-1.svg";

const useStyles = makeStyles(() => ({
    unhappyIcon: {

    }
}));

const UnhappyIcon = ({
    className,
    onClick
}) => {
    const classes = useStyles();
    return (
        <StreamlineIcon
            className={clsx(classes.unhappyIcon, className)}
            onClick={onClick}
        >
            <SmileyUnhappy1/>
        </StreamlineIcon>
    );
};

UnhappyIcon.defaultProps = {
};

UnhappyIcon.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func
};

export default UnhappyIcon;
